import { h } from 'preact';
import { getProductBadge, checkInventoryTreshold } from '../utils/helpers';

const ProductCardBadge = ({ currentProduct, currentVariant }) => {
  const skuBadge = currentVariant.sku;
  const tagBadge = getProductBadge(currentProduct.tags, 'badge_plp:');
  const hasComingSoonDate = currentProduct?.comingSoonDate?.value;
  const isComingSoonDateInFuture = new Date(currentProduct?.comingSoonDate?.value) > new Date();
  const isComingSoon = hasComingSoonDate && isComingSoonDateInFuture;
  const isSoldOut = !hasComingSoonDate && currentVariant.quantityAvailable < 1;
  const isLowInventory = checkInventoryTreshold(currentVariant);

  return (
    <div className="flex">
      {!!skuBadge && (
        <span className="block mb-1.5 heading-7 uppercase text-accent-1 h-3.5 laptop:h-[18px] pr-1">
          {skuBadge}
        </span>
      )}
      {(isComingSoon || isSoldOut || isLowInventory || tagBadge) && (
        <span
          className={`block mb-1.5 heading-7 uppercase text-accent-1 h-3.5 laptop:h-[18px] ${
            skuBadge ? 'pl-1 border-l border-grey-400' : ''
          }`}
        >
          {(isComingSoon && window.TMW.Strings.product.comingSoon)
            || (isSoldOut && window.TMW.Strings.product.soldOut)
            || (isLowInventory
              && `Only ${currentVariant.quantityAvailable} Left!`)
            || tagBadge}
        </span>
      )}
    </div>
  );
};

export default ProductCardBadge;
